'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _reactChartjs = require('react-chartjs-2');

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _chart = require('./chart');

var _chart2 = _interopRequireDefault(_chart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(num) {
  return (0, _numeral2.default)(num).format(0, 0);
};

var displayBlock = {
  display: 'block'
};

var barOptions = {
  tooltips: {
    mode: 'index',
    intersect: false
  },
  responsive: true,
  showScale: false,
  scales: {
    xAxes: [{
      stacked: true
    }],
    yAxes: [{
      stacked: true
    }]
  }
};

var youtubeVideoStyle = {
  maxWidth: '640px'
};

var getTimeStamp = function getTimeStamp(post) {
  return (0, _moment2.default)(post.latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');
};

var YoutubeWatchingStats = function YoutubeWatchingStats(_ref) {
  var mainData = _ref.mainData,
      heroPost = _ref.heroPost;
  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, color: 'red' },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Message,
        { icon: true },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'red' }),
        _react2.default.createElement(
          _semanticUiReact.Message.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            mainData.title
          ),
          mainData.subTitle
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 10, mobile: 16 },
            _react2.default.createElement(_reactPlayer2.default, { width: '100%', url: mainData.videoUrl, controls: true, style: youtubeVideoStyle })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 6, mobile: 16, textAlign: 'center' },
            _react2.default.createElement(
              'div',
              null,
              '\xA0',
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                { color: 'pink', size: 'small', style: displayBlock },
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  null,
                  cf(mainData.views)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play' }),
                  'views'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                { color: 'pink', size: 'small', style: displayBlock },
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  null,
                  cf(mainData.engagements)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'like' }),
                  'engagements'
                )
              ),
              '\xA0',
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                { color: 'pink', size: 'small', style: displayBlock },
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  null,
                  cf(mainData.watchTimeUKIre)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock' }),
                  'watch time UK/Ire (mins)'
                )
              ),
              '\xA0',
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                { color: 'pink', size: 'small', style: displayBlock },
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  null,
                  cf(mainData.watchTimeTotal)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock' }),
                  'watch time total (mins)'
                )
              ),
              '\xA0'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 4, mobile: 16 },
            _react2.default.createElement(
              'h4',
              null,
              'Who\'s watching? (views by gender)'
            ),
            _react2.default.createElement(_reactChartjs.Doughnut, { data: mainData.donutData })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 6, mobile: 16 },
            _react2.default.createElement(
              'h4',
              null,
              'Who\u2019s watching? (avg. watch time by age/gender)'
            ),
            _react2.default.createElement(_reactChartjs.HorizontalBar, { data: mainData.barData, options: barOptions })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 6, mobile: 16, verticalAlign: 'middle' },
            _react2.default.createElement(
              'h4',
              { style: { marginTop: '20px', marginBottom: '5px' } },
              'Where are they watching?'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table,
              { celled: true, stackable: true, fluid: true, size: 'small', basic: 'very', textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'country'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'watch time'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'views'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'likes'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _lodash2.default.map(mainData.viewingData, function (d) {
                  return _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      d.name
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      cf(d.watchTime * (mainData.scaleFactor || 1))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      cf(d.views * (mainData.scaleFactor || 1))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      cf(d.likes * (mainData.scaleFactor || 1))
                    )
                  );
                })
              )
            ),
            '\xA0'
          )
        )
      )
    ),
    heroPost && _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center' },
      _react2.default.createElement(
        'h4',
        null,
        'Total and Daily Viewing over time'
      ),
      _react2.default.createElement(_chart2.default, { trackedAsset: heroPost }),
      _react2.default.createElement(_semanticUiReact.Label, {
        centered: true,
        icon: 'clock',
        color: 'grey',
        basic: true,
        content: 'data collected ' + getTimeStamp(heroPost)
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { extra: true },
      'youtube engagements are calculated as likes + comments + shares'
    )
  );
};

exports.default = YoutubeWatchingStats;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/youtube-watching-stats/index.js
 ** module id = 2575
 ** module chunks = 0
 **/